module.exports = __webpack_public_path__ + "static/media/16.304649bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shoes/16.png
// module id = 1513
// module chunks = 0